<template>
  <div>
    <b-row class="mt-2" align-h="center">
      <b-col class="mt-4" v-for="(items, key) in modulos" :key="key" cols="3">
        <b-card
          :style="modulo==items.id_modulo ?'background:rgba(15, 55, 110, 0.3)':''"
          :header="'Módulo '+(key+1)"
          header-class="header-info"
          class="mx-auto card-info text-center"
        >
          <b-card-text>
            <p class="info-text mt-1">{{items.titulo}}</p>
            <br />
            <b-row align-h="around">
              <p>
                <img
                  style="cursor:pointer"
                  class="mr-5"
                  @click="editarclave(items.id_modulo)"
                  src="@/assets/images/editinfo.png"
                  alt
                />
                <img
                  style="cursor:pointer"
                  class="ml-5"
                  @click="editarclave()"
                  src="@/assets/images/eraseinfo.png"
                  alt
                />
              </p>
            </b-row>
          </b-card-text>
        </b-card>
      </b-col>
    </b-row>
    <b-row class="mt-5" align-h="center">
      <b-col class="mt-5 claves-row" cols="4">
        <b-row style="text-align:center" align-h="center">
          <b-col class="claves-titulo" cols="4">Pregunta</b-col>
          <b-col class="claves-titulo" cols="4">Respuesta</b-col>
          <b-col class="claves-titulo" cols="4">Modificar</b-col>
        </b-row>
        <b-row class="row-clave" v-for="(items, key) in preguntas" :key="key" align-h="center">
          <b-col :id="'pregunta'+key" cols="4">{{key+1}}</b-col>
          <b-tooltip custom-class="toptip-pregunta" :target="'pregunta'+key">
            <p v-html="items.descripcion"></p>
          </b-tooltip>
          <b-col cols="4">
            <select class="input-clave" disabled name :id="'opcion'+key">
              <option
                v-for="(item, i) in items.opcion"
                :key="i"
                :selected="item.correcta===1 ? true : false"
                :value="JSON.stringify(item)"
              >{{item.letra}}</option>
            </select>
          </b-col>
          <b-col cols="4">
            <img
              @click="edit(key)"
              :id="'edit'+key"
              style="cursor:pointer"
              src="@/assets/images/editinfo.png"
              alt
            />
            <img
              @click="save(key,)"
              :id="'save'+key"
              style="cursor:pointer; display:none"
              src="@/assets/images/save.png"
              alt
            />
          </b-col>
        </b-row>
      </b-col>
    </b-row>
  </div>
</template>
<script>
export default {
  name: "Editar",

  data: () => ({
    modulos: [],
    preguntas: [],
    modulo: "",
    opcion: []
  }),
  created() {
    this.$store.dispatch("setModulo", "Editar Claves");
    this.$store.dispatch("setNav", "active");
    this.getModulos();
    this.getPreguntas();
  },
  methods: {
    editarclave(id) {
      localStorage.setItem("id_modulo", id);
      this.getPreguntas();
    },
    getPreguntas() {
         this.modulo = localStorage.getItem("id_modulo");
      this.$store
        .dispatch("getPreguntasModulo", localStorage.getItem("id_modulo"))
        .then(response => {
          this.preguntas = response.data.preguntas;
        })
        .catch(error => {
          console.log(error.message);
        });
    },
    getModulos() {
      this.$store
        .dispatch("getModulosSimulacros", localStorage.getItem("id_simulacro"))
        .then(response => {
          this.modulos = response.data.modulos;
        })
        .catch(error => {
          console.log(error.message);
        });
    },

    edit(i) {
      document.getElementById("opcion" + i).removeAttribute("disabled");
      document.getElementById("edit" + i).style.display = "none";
      document.getElementById("save" + i).style.display = "inline";
    },
    save(i) {
      document.getElementById("opcion" + i).setAttribute("disabled", true);
      document.getElementById("edit" + i).style.display = "inline";
      document.getElementById("save" + i).style.display = "none";

      var data = JSON.parse(document.getElementById("opcion" + i).value);

      this.$store
        .dispatch("postUpdateClave", data)
        .then(response => {
          //this.modulos = response.data.modulos;
          console.log(response.data);
        })
        .catch(error => {
          console.log(error.message);
        });
    },

    modificar(item) {
      localStorage.setItem("item", JSON.stringify(item));
      this.$router.push({
        name: "editar-informacion-id"
      });
    }
  },
  computed: {
    isAdmin() {
      return this.$store.getters["isAdmin"];
    }
  }
};
</script>
<style scoped>
</style>